<div class="switch-button__wrapper" [ngClass]="{ 'disable': disable }">
    <label class="switch-button" (click)="toggle()">
        {{ text }}
        <span class="hidden-checkbox" [class.active]="active"></span>
        <span></span>
    </label>
</div>
